import { useState } from 'react';

export const useActionButtonShortcutImpl = () => {
  const [showSideModal, setShowSideModal] = useState(false);
  const [showShortcutSideModal, setShowShortcutSideModal] = useState(false);
  const [showAutoReportModal, setShowAutoReportModal] = useState(false);
  const [isShortcut, setIsShortcut] = useState(false);

  const closeBankMaintenanceSideModal = () => {
    setShowSideModal(false);
    if (isShortcut) {
      setShowShortcutSideModal(true);
    }
  };

  const closeShortcutSideModal = () => {
    setShowShortcutSideModal(false);
    setIsShortcut(false);
  };

  const openShortcutSideModal = () => {
    setShowShortcutSideModal(true);
    setIsShortcut(true);
  };

  const handleAutoReportModal = () => {
    setShowAutoReportModal(true);
    setIsShortcut(true);
    setShowShortcutSideModal(false);
  };

  const state = {
    showSideModal,
    showShortcutSideModal,
    showAutoReportModal,
    isShortcut,
  };

  const action = {
    closeBankMaintenanceSideModal,
    closeShortcutSideModal,
    openShortcutSideModal,
    handleAutoReportModal,
    setShowAutoReportModal,
    setShowShortcutSideModal,
    setShowSideModal,
    setIsShortcut,
  };

  return { state, action };
};
